import React from "react";
import { useState } from "react";

import TableRow from "../../../Components/Admin/Specialists/TableRow";
import AddModal from "../../../Components/Admin/Specialists/AddModel";
import EditModal from "../../../Components/Admin/Specialists/EditModel";
import DeleteModal from "../../../Components/Admin/shared/DeleteModel";
import Header from "../../../Components/Admin/shared/HeaderTable";

const rowsText = [
  "Show In Website",
  "Name",
  "Phone",
  "City",
  "District",
  "Degree",
  "Specialization",
  "Years Of Experience",
  "Actions",
  "Gender",
  "Brief",
  "Resume",
  "Graduation Certificate",
  "Card ID",
  "createdAt",
  "updatedAt",
];

const searchTypes = [
  "fullName",
  "phone",
  "email",
  "brief",
  "city",
  "district",
  "degree",
  "specialization",
  "yearsOfExperience",
  "gender",
];

const itemsPerPage = 5;

const Specialists = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [search, setSearch] = useState("");
  const [searchType, setTypeSearch] = useState("");
  const [searchAction, setSearchAction] = useState(false);

  const [idUserForDelete, setIdUserForDelete] = useState(0);

  const [userInfoForUpdate, setUserInfoForUpdate] = useState(0);

  const [status, setStatus] = useState({
    show: false,
    icon: "success",
    title: "",
    description: "",
    showConfirmButton: true,
    timer: 10000,
  });

  function handleModal(setState, value) {
    setState(value);
  }

  return (
    <>
        <div className=' md:p-10  p-4 bg-[#f5f5f5]'>
          <Header
            setSearch={setSearch}
            setTypeSearch={setTypeSearch}
            handleModal={handleModal}
            setIsAdd={setIsAdd}
            searchTypes={searchTypes}
            title={"Search users"}
            setSearchAction={setSearchAction}
          />

          <TableRow
            title={"Specialists List"}
            setIsEdit={setIsEdit}
            setIsDelete={setIsDelete}
            handleModal={handleModal}
            rows={rowsText}
            search={search}
            searchType={searchType}
            itemsPerPage={itemsPerPage}
            setIdUserForDelete={setIdUserForDelete}
            status={status}
            setStatus={setStatus}
            searchAction={searchAction}
            setSearchAction={setSearchAction}
            setUserInfoForUpdate={setUserInfoForUpdate}
          />

          <AddModal
            handleModal={handleModal}
            setIsAdd={setIsAdd}
            isAdd={isAdd}
            setStatus={setStatus}
          />

          <EditModal
            handleModal={handleModal}
            setIsEdit={setIsEdit}
            isEdit={isEdit}
            setStatus={setStatus}
            idForDelete={idUserForDelete}
            userInfoForUpdate={userInfoForUpdate}
          />

          <DeleteModal
            handleModal={handleModal}
            setIsDelete={setIsDelete}
            isDelete={isDelete}
            idForDelete={idUserForDelete}
            setStatus={setStatus}
            url={"admin/delete_specialist"}
          />
        </div>
    </>
  );
};

export default Specialists;
